import styled from "styled-components";

export const BurgerSocialsWrapper = styled.div`
  position: absolute;
  bottom: 0;
  left: 20px;
`;

export const LeftSocialBar = styled.div`
  position: absolute;
  bottom: 0;
  left: 30px;
  height: 225px;
  width: 40px;
  display: flex;
  flex-direction: column;
  align-items: center;
  background-color: rgb(32, 32, 32);
`;

export const IconsWrapper = styled.div`
  position: absolute;
  display: flex;
  flex-direction: column;
  background-color: rgb(32, 32, 32);
  /* gap: 40px; */
  > * + * {
    margin-top: 40px;
  }
  :hover & {
    color: var(--main-color);
  }
  a:hover svg {
    stroke: var(--main-color);
  }
`;

export const VerticalLineLeft = styled.div`
  position: absolute;
  bottom: 0;
  width: 1px;
  height: 100px;
  background-color: #fff;
  opacity: 40%;
`;

export const IconNames = styled.div`
  font-family: "Raleway", sans-serif;
  font-weight: 200;
  font-size: 14px;
  background-color: rgb(32, 32, 32);
`;

export const IconTextWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  background-color: rgb(32, 32, 32);
  > * + * {
    margin-top: 10px;
  }
`;
/*---------------------------------------- */
export const RightSocialBar = styled.div`
  position: absolute;
  bottom: 0;
  right: -230px;
  height: 292px;
  width: 40px;
  display: flex;
  flex-direction: column;
  align-items: center;
  background-color: rgb(32, 32, 32);
`;

export const EmailText = styled.div`
  position: absolute;
  font-family: "Raleway", sans-serif;
  font-weight: 200;
  font-size: 14px;
  writing-mode: vertical-rl;
  background-color: rgb(32, 32, 32);
`;

export const VerticalLineRight = styled.div`
  position: absolute;
  bottom: 0;
  width: 1px;
  height: 100px;
  background-color: #fff;
  opacity: 40%;
`;
